import { StyleApi } from '../../../api/styles/style-api.model';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { StylesSubjectTypesApiEnum } from '../../../api/styles/enum/styles-subject-types-api.enum';
import { GenericStyleModel } from './generic-style.model';
import { Template } from './template.model';
import { BaseModel } from '../../Basic/models/base.model';

export class Style extends BaseModel<Style, StyleApi> {
    id: number;
    name: string;

    style: GenericStyleModel;
    type: StyleTypesApiEnum;
    template: Template;
    defaultReference?: string;

    createdByUserId: number;
    createdDate: Date;

    lastModifiedByUserId: number;
    lastModifiedDate: Date;

    constructor(styleApi?: StyleApi) {
        super();
        if (styleApi) {
            this.constructFromApiModel(styleApi);
        } else {
            this.constructDefault();
        }
    }

    toApiModel(): StyleApi {
        return {
            id:               this.id,
            name:             this.name,
            style:            this.style.toApi ? this.style.toApi() : JSON.parse(JSON.stringify(this.style)),
            subjectType:      this.type,
            subject:          StylesSubjectTypesApiEnum.TEMPLATE,
            createdByUserId:  this.createdByUserId,
            createdDate:      this.createdDate,
            modifiedByUserId: this.lastModifiedByUserId,
            modifiedDate:     this.lastModifiedDate
        };
    }

    constructFromApiModel(apiModel: StyleApi) {
        this.id = apiModel.id;
        this.name = (apiModel.name && apiModel.name.length)
            ? apiModel.name : 'No name set';

        this.style = apiModel.style;
        this.type = apiModel.subjectType;

        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = apiModel.createdDate;

        this.lastModifiedByUserId = apiModel.modifiedByUserId;
        this.lastModifiedDate = apiModel.modifiedDate;
    }

    clone(): Style {
        const clone = new Style(this.toApiModel());
        clone.style = this.style.clone ? this.style.clone() : JSON.parse(JSON.stringify(this.style));
        if (this.template) {
            clone.template = this.template.clone();
        }

        return clone;
    }

    equals(other?: Style): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.createdByUserId !== other.createdByUserId) {
            return false;
        }

        if (this.createdDate !== other.createdDate) {
            return false;
        }

        if (this.lastModifiedByUserId !== other.lastModifiedByUserId) {
            return false;
        }

        if (this.lastModifiedDate !== other.lastModifiedDate) {
            return false;
        }

        if (!this.style.equals(other.style, true)) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (this.template !== other.template) {
            return false;
        }

        if (this.defaultReference !== other.defaultReference) {
            return false;
        }

        return true;
    }

    constructDefault() {
        this.template = null;
    }
}
